import React, { useState, useEffect } from "react"
import { Row, Col, UncontrolledTooltip, Button } from "reactstrap"
import { withRouter, useParams } from "react-router-dom"
import PropTypes from "prop-types"
import { get, isEmpty } from "lodash"
//import { connect, useSelector, useDispatch } from "react-redux"
import { connect, useSelector } from "react-redux"
import * as followupAction from "../../store/Zm9sbG93dXA/actions"
import moment from "moment"
import Modal from "react-bootstrap/Modal"

const FollowUpHistoryDetails = (props) => {
  //const [formData, setFormData] = useState([])
  const { dispatch, dateFormate } = props
  let { id } = useParams()
  console.log(dateFormate, "dateFormate")
  useEffect(() => {
    dispatch(followupAction.loadFollowHistoryDetails(id))
  }, [])

  const followupUpdate = useSelector((specificState) => specificState.followup)
  const { followup_history = [] } = followupUpdate
  const followupHistoryTableDetails =
    !isEmpty(followup_history) && followup_history ? followup_history : []

  const [modal, setModal] = useState(false)
  const [audioFile, setAudioFile] = useState("")
  const handleClose = () => setModal(false)
  let followupHistoryTableDetailsUpdated = []

  if (followupHistoryTableDetails) {
    followupHistoryTableDetailsUpdated = !isEmpty(followupHistoryTableDetails)
      ? followupHistoryTableDetails.map((followup, index) => {
          var attachmentFiles = get(followup, "recordAttachment", [])
          var attachmentFileArray = []
          if (attachmentFiles && attachmentFiles.length > 0) {
            for (let i = 0; i < attachmentFiles.length; i++) {
              var attachmentFile = attachmentFiles[i]
              var attachmentType = "file"
              if (attachmentFile) {
                var attachmentFileExtenstion = attachmentFile.split(".")
                var attachmentFileExtenstionType =
                  attachmentFileExtenstion[attachmentFileExtenstion.length - 1]

                if (attachmentFileExtenstionType) {
                  if (
                    attachmentFileExtenstionType == "jpg" ||
                    attachmentFileExtenstionType == "png" ||
                    attachmentFileExtenstionType == "jpeg"
                  ) {
                    attachmentType = "image"
                  } else if (
                    attachmentFileExtenstionType == "mp3" ||
                    attachmentFileExtenstionType == "wav" ||
                    attachmentFileExtenstionType == "mp4" ||
                    attachmentFileExtenstionType == "m4a" ||
                    attachmentFileExtenstionType == "m4b" ||
                    attachmentFileExtenstionType == "msv" ||
                    attachmentFileExtenstionType == "mmf" ||
                    attachmentFileExtenstionType == "m4p" ||
                    attachmentFileExtenstionType == "wma" ||
                    attachmentFileExtenstionType == "aac" ||
                    attachmentFileExtenstionType == "ac3" ||
                    attachmentFileExtenstionType == "aiff" ||
                    attachmentFileExtenstionType == "flac" ||
                    attachmentFileExtenstionType == "ogg" ||
                    attachmentFileExtenstionType == "opus" ||
                    attachmentFileExtenstionType == "ts" ||
                    attachmentFileExtenstionType == "wav" ||
                    attachmentFileExtenstionType == "amr"
                  ) {
                    attachmentType = "audio"
                  }
                }
              }

              var attachmentObject = {
                attachment: attachmentFile,
                attachmentType: attachmentType,
              }
              attachmentFileArray.push(attachmentObject)

              // attachment loop end
            }
          }

          return {
            key: index,
            id: get(followup, "_id", ""),
            remarks: get(followup, "remarks", ""),
            futureFollowupRemark: get(followup, "futureFollowupRemark", ""),
            attachmentfile: attachmentFileArray,
            attachment: get(followup, "recordAttachment[0]", ""),
            clientReachedStatus: get(followup, "clientReachedStatus", ""),
            overallStatus: get(followup, "overallStatus", ""),
            attachmentType: attachmentType,
            historyDate: followup.createdAt
              ? moment(followup.createdAt).format("YYYY-MM-DD hh:mm A")
              : "",
          }
        })
      : []

    console.log(
      "followupHistoryTableDetailsUpdated",
      followupHistoryTableDetailsUpdated
    )
  }

  return (
    <React.Fragment>
      <Row>
        <Col md="12" xl="12" lg="12" className="mt-3">
          {followupHistoryTableDetailsUpdated &&
          followupHistoryTableDetailsUpdated.length < 0 ? (
            <div>
              <br />
              <h5>No Data Found !!!</h5>
            </div>
          ) : (
            <Row className="quote-head-content">
              <Col md="7" xl="7" lg="7">
                <p className="quote-head">
                  Followup Strategy
                  <span className="quote-info">
                    <i
                      style={{ color: "grey" }}
                      id="quoteInfo1"
                      aria-hidden="true"
                      className="fa fa-info-circle ms-1"
                    ></i>
                    <UncontrolledTooltip placement="right" target="quoteInfo1">
                      FollowUp Strategy Description
                    </UncontrolledTooltip>
                  </span>
                </p>
              </Col>

              <Col md="5" xl="5" lg="5">
                <p className="quote-head">
                  Current FollowUp
                  <span className="quote-info">
                    <i
                      style={{ color: "grey" }}
                      id="quoteInfo2"
                      aria-hidden="true"
                      className="fa fa-info-circle ms-1"
                    ></i>
                    <UncontrolledTooltip placement="right" target="quoteInfo2">
                      CUrrent Followup Description
                    </UncontrolledTooltip>
                  </span>
                </p>
              </Col>
            </Row>
          )}
        </Col>
        {followupHistoryTableDetailsUpdated &&
        followupHistoryTableDetailsUpdated.length > 0
          ? followupHistoryTableDetailsUpdated.map((item) => {
              const historyDate =
                !isEmpty(item) && item.historyDate
                  ? moment(item.historyDate)
                      .subtract(5, "hours")
                      .subtract(30, "minutes")
                      .format(`${dateFormate} hh:mm A`)
                  : []

              console.log(historyDate, "historyDate")
              return (
                <>
                  <Row>
                    <Col className="followup-history-content" key={item.key}>
                      <Row className="d-flex flex-row mt-3 mb-3">
                        <Col
                          md="4"
                          lg="4"
                          xl="4"
                          className="followup-strategy-main"
                        >
                          <p className="followup-strategy-content">
                            {item.futureFollowupRemark &&
                            item.futureFollowupRemark[0]
                              ? item.futureFollowupRemark[0]
                              : ""}
                          </p>
                        </Col>
                        <Col
                          md="3"
                          lg="3"
                          xl="3"
                          className="ms-1 followup-history-date"
                        >
                          {historyDate}

                          {item && item.attachmentfile.length > 0 ? (
                            item.attachmentfile.map((items) => {
                              return (
                                <>
                                  <p className="history-audio-div">
                                    <span>
                                      <a
                                        href={
                                          items.attachment
                                            ? items.attachment
                                            : ""
                                        }
                                        target={"_blank"}
                                        rel={"noreferrer"}
                                        className={
                                          items.attachment
                                            ? ""
                                            : "disabled-button"
                                        }
                                      >
                                        <i
                                          style={{
                                            color: "black",
                                            fontSize: "18px",
                                          }}
                                          aria-hidden="true"
                                          className="fa fa-download ms-1"
                                        ></i>
                                      </a>
                                    </span>
                                    &nbsp;&nbsp;&nbsp;
                                    <span>
                                      <i
                                        style={{
                                          color: "black",
                                          fontSize: "18px",
                                        }}
                                        aria-hidden="true"
                                        className={
                                          items.attachment &&
                                          items.attachmentType == "audio"
                                            ? "fa fa-volume-up ms-1"
                                            : "fa fa-volume-up ms-1 disabled-button"
                                        }
                                        onClick={() => {
                                          setModal(true)
                                          setAudioFile(items.attachment)
                                        }}
                                        id="quoteInfo3"
                                      ></i>
                                      <UncontrolledTooltip
                                        placement="right"
                                        target="quoteInfo3"
                                      >
                                        Click here to listen to the recording.
                                      </UncontrolledTooltip>
                                    </span>
                                  </p>
                                </>
                              )
                            })
                          ) : (
                            <div></div>
                          )}

                          <p className="history-audio-div"></p>
                        </Col>
                        <Col
                          md="4"
                          lg="4"
                          xl="4"
                          className="current-followup-main"
                        >
                          <p className="current-followup-content">
                            {item.remarks ? item.remarks : ""}
                          </p>
                          <h5 className="current-followup-heading-content">
                            Over All Status
                          </h5>
                          <p className="current-followup-content">
                            {item.overallStatus ? item.overallStatus : ""}
                          </p>
                          <h5 className="current-followup-heading-content">
                            Reach Status
                          </h5>
                          <p className="current-followup-content">
                            {item.clientReachedStatus
                              ? item.clientReachedStatus
                              : ""}
                          </p>
                        </Col>
                      </Row>
                    </Col>

                    {modal && (
                      <Modal show={modal} onHide={handleClose}>
                        <Modal.Header>Recording File</Modal.Header>
                        <Modal.Body>
                          <div className="followup-history-audio-modal-div">
                            <audio controls>
                              <source src={audioFile} type="audio/mpeg" />
                              Your browser does not support the audio element.
                            </audio>
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            className="btn btn-danger"
                            onClick={handleClose}
                          >
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    )}
                  </Row>
                </>
              )
            })
          : ""}
      </Row>
    </React.Fragment>
  )
}

FollowUpHistoryDetails.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.object,
  records: PropTypes.array,
  followupHistoryRecord: PropTypes.array,
  error: PropTypes.any,
  dateFormate: PropTypes.any,
  access: PropTypes.array,
  metaData: PropTypes.object,
  loading: PropTypes.any,
  success: PropTypes.any,
}
const mapStateToProps = (state) => ({
  followupProps: state.followup.followupHistoryRecord,
})

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FollowUpHistoryDetails)
)
